import { IGoalDatapointLatest } from 'motw_core/DTOs/goaldatapointlatest';
import { IGoal } from 'motw_core/Entity/IGoal';
import * as React from 'react';
import { GoalCardBody } from 'source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/Body/GoalCardBody';
import { IGoalStreakInfoDTO } from 'motw_core/DTOs/GoalStreakInfo/IGoalStreakInfoDTO';

export function GoalCardContents({
	goal,
	isGameIdentityGoal,
	goalDatapointLatest,
	goalStreakInfo
}: {
	goal: IGoal;
	isLoggedToday: boolean;
	isGameIdentityGoal: boolean;
	goalDatapointLatest?: IGoalDatapointLatest;
	goalStreakInfo: IGoalStreakInfoDTO;
}) {
	return (
		<div
			id="goalCardContents"
			style={{
				width: `50px`,
				height: `70px`,
				backgroundSize: `cover`,
				display: `flex`,
				alignItems: `center`,
				justifyContent: `center`,
				position: `relative`,
			}}
		>
			<GoalCardBody
				goal={goal}
				isGameIdentityGoal={isGameIdentityGoal}
				goalDatapointLatest={goalDatapointLatest}
				goalStreakInfo={goalStreakInfo}
			/>
		</div>
	);
}
